import Vue from 'vue'
import VueRouter from 'vue-router'
import top from '../components/top.vue'
import products from '../components/products.vue'
import detail from '../components/detail.vue'
import article from '../components/article.vue'
import news from '../components/news.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'top',
    component: top
  },
  {
    path: '/products',
    name: 'products',
    component: products,
    children: [
      {
        path: '/products/:num',
      },
    ]
  },
  {
    path: '/products/detail/:hin',
    component: detail,
  },
  {
    path:'/news',
    component: news,
  },
  {
    path: '/news/:id',
    component: article,
  },
  {
    path: '/maintenance/',
    redirect: '/maintenance/maintenance.html',
  },
  {
    path: '*',
    redirect: '/',
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
